export default __webpack_public_path__ + "static/media/6.e48bee1d.jpeg";